const mutations = {
  SET_COLOR: (state, color) => {
    state.color = color
  },
  SET_IMAGE: (state, image) => {
    state.image = image
  },
  SET_TIMER: (state, timer) => {
    state.timer = timer
  },
  SET_INTEREST: (state, interest) => {
    state.interest = interest
  },
  SET_PAYMENTS: (state, payments) => {
    state.payments = payments
  },
  SET_FREE_FREIGHT: (state, freeFreight) => {
    state.free_freight = freeFreight
  },
  SET_EMAIL_REQUIRED: (state, emailRequired) => {
    state.email_required = emailRequired
  },
  SET_SETTINGS: (state, settings) => {
    Object.assign(state, settings)
  },
}

export default mutations
